<template>
    <b-navbar v-editable="blok" toggleable="lg" type="light" :class="blok.sticky ? 'sticky-nav' : ''">
        <component :key="i+'-label'" v-for="(component,i) in blok.nav_components" :blok="component" :is="component.component"></component>
        <component :key="indexB" v-for="(child,indexB) in blok.mobile_buttons" :blok="child" :target="getMobileButtonTarget(child.component)" :is="child.component"></component>
        <b-collapse id="nav-collapse" is-nav>
            <navigation :class="{'ml-auto': nav.right_align}" :right="nav.right_align" :key="indexC" v-for="(nav,indexC) in blok.nav" :items="nav.items" class="navbar-nav"></navigation>
        </b-collapse>
  </b-navbar>
</template>
<script>
import { mapActions, mapState } from "vuex";

import NavigationMobileButtonGeneral from "./NavigationMobileButtonGeneral.vue";
import NavigationMobileButtonShopify from "../shopify/NavigationMobileButtonShopify.vue";
import MobileBasketButton from '../basket/MobileBasketButton';
import NavigationLogo from "./NavigationLogo.vue";
import NavigationAlert from "./NavigationAlert.vue";

import Nav from "./Nav.vue";

export default {
  name: "navigation-bar",
  props: {
    'blok': Object
  },
  components: {
    'navigation': Nav,
    'navigation-mobile-button-shopify': NavigationMobileButtonShopify,
    'navigation-mobile-button-general': NavigationMobileButtonGeneral,
    'navigation-logo': NavigationLogo,
    'mobile-basket-button': MobileBasketButton,
    'navigation-alert': NavigationAlert
  },
  methods: {
    getMobileButtonTarget: function(component) {
      if(component=='navigation-mobile-button-general'){
        return 'nav-collapse'
      }
      return ''
    }
  }
};
</script>
